import { render, staticRenderFns } from "./boatKf.vue?vue&type=template&id=25db74e8&scoped=true&"
import script from "./boatKf.vue?vue&type=script&lang=js&"
export * from "./boatKf.vue?vue&type=script&lang=js&"
import style0 from "./boatKf.vue?vue&type=style&index=0&id=25db74e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db74e8",
  null
  
)

export default component.exports